import debounce from 'debounce'

const mapEl = document.getElementById('map')
if (mapEl) {
	window.addEventListener('load', initMap)
}

function initMap() {
	const centerPosition = {
		lat: _mapMarker.latitude,
		lng: _mapMarker.longitude,
	}
	var bounds = new google.maps.LatLngBounds()
	bounds.extend(
		new google.maps.LatLng(_mapMarker.latitude, _mapMarker.longitude)
	)

	let zoomLevel
	if (window.innerWidth >= 1200) {
		zoomLevel = 15
	} else if (window.innerWidth >= 992) {
		zoomLevel = 14
	} else {
		zoomLevel = 13
	}

	const map = new google.maps.Map(document.getElementById('map'), {
		center: centerPosition,
		zoom: zoomLevel,
		mapId: '7b182fcc799e33d8',
		disableDefaultUI: true,
	})

	// map.setOptions({draggable: false, zoomControl: false, scrollwheel: false, disableDoubleClickZoom: true});
	map.setOptions({ scrollwheel: false })

	const image = {
		url: '/wp-content/themes/propaganda-theme/assets/svg/map-marker-gold.svg',
		size: new google.maps.Size(52, 80),
		origin: new google.maps.Point(0, 0),
		anchor: new google.maps.Point(26, 80),
	}

	const marker = new google.maps.Marker({
		position: {
			lat: _mapMarker.latitude,
			lng: _mapMarker.longitude,
		},
		map,
		icon: image,
	})

	const refreshCenter = debounce(() => {
		// TODO: This is slightly annoying/unsightly when resizing the screen, clean it up if we have time
		map.setCenter(centerPosition)

		if (window.innerWidth < 1200) {
			return
		}
		// retrieve the lat lng for the far extremities of the (visible) map
		var latLngBounds = map.getBounds()
		var neBound = latLngBounds.getNorthEast()
		var swBound = latLngBounds.getSouthWest()

		// convert the bounds in pixels
		var neBoundInPx = map.getProjection().fromLatLngToPoint(neBound)
		var swBoundInPx = map.getProjection().fromLatLngToPoint(swBound)

		var offset
		if (window.innerWidth >= 992) {
			offset = (neBoundInPx.x - swBoundInPx.x) * 0.25
		}

		var center = map.getCenter()
		var centerPoint = map.getProjection().fromLatLngToPoint(center)
		centerPoint.x -= offset
		map.setCenter(map.getProjection().fromPointToLatLng(centerPoint))
	}, 100)

	map.addListener('projection_changed', () => {
		refreshCenter()
	})

	window.addEventListener('resize', () => {
		refreshCenter()
	})

	google.maps.event.addListenerOnce(map, 'idle', () => {
		refreshCenter()
	})
}
